import {
    createChart
} from 'util/reports';
import {ONE_ELEMENT, INIT_INDEX} from 'util/constants';
import {invalidateReports} from 'modules/store/reports';

const reportsUIItems = ['account', 'cost_center', 'vendor'];

const _defaultStateItem = () => ({
    config:        null,
    selectedLevel: [],
    search:        undefined,
    spending:      {
        selectedMenu: null,
        selectedRows: [],
        allOpened:    false
    },
    sortItem: {
        field: 'name',
        sort:  'desc'
    }
});
const _defaultState = () => reportsUIItems.reduce((value, item) => ({
    ...value,
    [item]: _defaultStateItem()
}), {});

export const invalidateReportsUI = () => dispatch => {
    dispatch(invalidateReports());
};

const CREATE_REPORT_CHART = 'CREATE_REPORT_CHART';

export const createReportChart = (section, tree, levels, name, handler) => ({
    type: CREATE_REPORT_CHART,
    section, tree, levels, name, handler
});
const _createReportChart = (state, {section, tree, levels, name, handler}) => ({
    ...state,
    [section]: {
        ...state[section],
        config: {
            ...createChart(tree, levels, name, handler)
        }
    }
});

const _sortReportTotalWidget = (state, {section, field, sort}) => ({
    ...state,
    [section]: {
        ...state[section],
        sortItem: {
            field,
            sort
        }
    }
});


const CHANGE_MENU_SPENDING_BREAKDOWN = 'CHANGE_MENU_SPENDING_BREAKDOWN';

export const changeMenuSpendingBreakdown = (section, menuItem, selectedRows = []) => ({
    type: CHANGE_MENU_SPENDING_BREAKDOWN,
    section, menuItem, selectedRows
});

const SORT_REPORT_TOTAL_WIDGET = 'SORT_REPORT_TOTAL_WIDGET';

export const sortReportTotalWidget = (section, field, sort) => ({
    type: SORT_REPORT_TOTAL_WIDGET,
    section, field, sort
});

const _changeMenuSpendingBreakdown = (state, {section, menuItem, selectedRows}) => ({
    ...state,
    [section]: {
        ...state[section],
        spending: {
            ...state[section].spending,
            selectedMenu: menuItem,
            selectedRows
        }
    }
});

const SELECT_ALL_SELECTEDROWS_SPENDING_BREAKDOWN = 'SELECT_ALL_SELECTEDROWS_SPENDING_BREAKDOWN';

export const selectAllSelectedRowsSpendingBreakdown = (section, items) => ({
    type: SELECT_ALL_SELECTEDROWS_SPENDING_BREAKDOWN,
    section, items
});
const _selectAllSelectedRowsSpendingBreakdown = (state, {section, items}) => ({
    ...state,
    [section]: {
        ...state[section],
        spending: {
            ...state[section].spending,
            selectedRows: items.map(item => item.id),
            allOpened:    true
        }
    }
});

const CHANGE_SELECTEDROWS_SPENDING_BREAKDOWN = 'CHANGE_SELECTEDROWS_SPENDING_BREAKDOWN';

export const changeSelectedRowsSpendingBreakdown = (section, item) => ({
    type: CHANGE_SELECTEDROWS_SPENDING_BREAKDOWN,
    section, item
});
const _changeSelectedRowsSpendingBreakdown = (state, {section, item}) => {
    const
        {selectedRows} = state[section].spending,
        index = selectedRows.indexOf(item.id);

    if (~index) {
        selectedRows.splice(index, ONE_ELEMENT);
    } else {
        selectedRows.push(item.id);
    }

    return {
        ...state,
        [section]: {
            ...state[section],
            spending: {
                ...state[section].spending,
                selectedRows: selectedRows.slice(),
                allOpened:    false
            }
        }
    };
};

const OPEN_ALL_ROWS_SPENDING_BREAKDOWN = 'OPEN_ALL_ROWS_SPENDING_BREAKDOWN';

export const openAllRowsSpendingBreakdown = section => ({
    type: OPEN_ALL_ROWS_SPENDING_BREAKDOWN,
    section
});
const _openAllRowsSpendingBreakdown = (state, {section}) => ({
    ...state,
    [section]: {
        ...state[section],
        spending: {
            ...state[section].spending,
            allOpened: true
        }
    }
});


const CLEAN_SELECTEDROWS_SPENDING_BREAKDOWN = 'CLEAN_SELECTEDROWS_SPENDING_BREAKDOWN';

export const cleanSelectedRowsSpendingBreakdown = section => ({
    type: CLEAN_SELECTEDROWS_SPENDING_BREAKDOWN,
    section
});
const _cleanSelectedRowsSpendingBreakdown = (state, {section}) => ({
    ...state,
    [section]: {
        ...state[section],
        spending: {
            ...state[section].spending,
            selectedRows: [],
            allOpened:    false
        }
    }
});

const SELECT_REPORT_LEVEL = 'SELECT_REPORT_LEVEL';

export const selectReportLevel = (section, selectedLevel) => ({
    type: SELECT_REPORT_LEVEL,
    section, selectedLevel
});

const _selectReportLevel = (state, {section, selectedLevel}) => {
    const _level = [];

    for (let i = INIT_INDEX; i < selectedLevel.level; i++) {
        _level[i] = state[section].selectedLevel[i];
    }

    _level[selectedLevel.level] = selectedLevel;

    return {
        ...state,
        [section]: {
            ...state[section],
            selectedLevel: _level
        }
    };
};

const BACK_REPORT_LEVEL = 'BACK_REPORT_LEVEL';

export const backReportLevel = (section, selectedLevel) => ({
    type: BACK_REPORT_LEVEL,
    section, selectedLevel
});

const _backReportLevel = (state, {section, selectedLevel}) => {
    let _selectedLevel = state[section].selectedLevel.slice();

    if (selectedLevel.target) {
        _selectedLevel.pop();
    } else if (typeof selectedLevel === 'string') {
        _selectedLevel = [];
    } else {
        _selectedLevel.splice(selectedLevel.level + ONE_ELEMENT, _selectedLevel.length);
    }

    return {
        ...state,
        [section]: {
            ...state[section],
            selectedLevel: _selectedLevel
        }
    };
};

const CHANGE_SEARCH_BILLING = 'CHANGE_SEARCH_BILLING';

export const changeSearchBilling = (section, search) => ({
    type: CHANGE_SEARCH_BILLING,
    section, search
});
const _changeSearchBilling = (state, {section, search}) => ({
    ...state,
    [section]: {
        ...state[section],
        selectedLevel: [],
        search
    }
});

export const reducer = (state = _defaultState(), action = {}) => {
    switch (action.type) {
    case CREATE_REPORT_CHART:
        return _createReportChart(state, action);
    case SORT_REPORT_TOTAL_WIDGET:
        return _sortReportTotalWidget(state, action);
    case SELECT_REPORT_LEVEL:
        return _selectReportLevel(state, action);
    case BACK_REPORT_LEVEL:
        return _backReportLevel(state, action);
    case CHANGE_MENU_SPENDING_BREAKDOWN:
        return _changeMenuSpendingBreakdown(state, action);
    case SELECT_ALL_SELECTEDROWS_SPENDING_BREAKDOWN:
        return _selectAllSelectedRowsSpendingBreakdown(state, action);
    case CHANGE_SELECTEDROWS_SPENDING_BREAKDOWN:
        return _changeSelectedRowsSpendingBreakdown(state, action);
    case OPEN_ALL_ROWS_SPENDING_BREAKDOWN:
        return _openAllRowsSpendingBreakdown(state, action);
    case CLEAN_SELECTEDROWS_SPENDING_BREAKDOWN:
        return _cleanSelectedRowsSpendingBreakdown(state, action);
    case CHANGE_SEARCH_BILLING:
        return _changeSearchBilling(state, action);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/reportsUI.js